export function namespace(name, translations) {
  return Object.keys(translations).reduce(function (hash, key) {
    hash[`${name}_${key}`] = translations[key];
    return hash;
  }, {});
}
